import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { SortableCards } from 'console/shared/components/features/sortable-cards';
import { PanelsKeys } from 'console/shared/content/panels/types';
import { memo, useCallback } from 'react';
import { VehicleCustomControlButton } from './button';
import * as S from './styles';
import { CustomControlProvider } from '../../../custom-controls/custom-controls-card/provider';
export const VehicleCustomControls = memo(function VehicleCustomControls(props) {
    const { custom_controls } = props;
    const component = useCallback((custom_control_config) => (_jsx(CustomControlProvider, { custom_control_config: custom_control_config, children: _jsx(VehicleCustomControlButton, {}) })), []);
    return (_jsx(Box, { width: isMediumUI() ? '70%' : '100%', fontSize: "0.7em", children: _jsx(S.VehicleCustomControls, { children: _jsx(SortableCards, { panel_key: PanelsKeys.vehicle_custom_controls, list: custom_controls, component: component, min_width: 140, repeat_value: "auto-fit" }) }) }));
});
